export const ChildCloseRelativesFields = [
    'parent', 'guardian', 'relative'
];
